/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.settings.controllers', [
  'ui.router',
  'acme.common.service.posConfig'
])

.controller('PosCreateSettingsController', ['$scope', 'PosConfigService', function($scope, PosConfigService) {

    $scope.posCreateSettings = {

      model: {
        enableCustomerInputOnPurchase: false
      },

      init: function() {
        $scope.$on('PosCreateController::Save', this.onPosCreateSave);
        $scope.$on('PosCreateController::UpdateModel', this.onPosCreateUpdateModel);

        this.getSettings();
      },

      getSettings: function() {
        this.model = PosConfigService.settings.getModel();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPosCreateSave: function() {
        PosConfigService.settings.setModel($scope.posCreateSettings.model);
      },

      onPosCreateUpdateModel: function(e, data) {
        var self = $scope.posCreateSettings;
        PosConfigService.settings.setModel(PosConfigService.settings.getModel());
        self.getSettings();
      }

    };

    $scope.posCreateSettings.init();

}]);